module.exports = __webpack_public_path__ + "static/img/Captura de tela de 2024-11-05 15-00-37.78f89fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Captura de tela de 2024-11-05 15-00-37.png
// module id = fuAX
// module chunks = 4